import { get } from 'lodash-es'
const LodashFn = {} // 需要导出的对象

LodashFn.install = function (Vue, options) {
  Vue.prototype.$useOptionChain = get
}

export default LodashFn
